module.exports = "https://coursera_assets.s3.amazonaws.com/images/b39a6595ef607fb025a11d820aeb2226.png";